import { Link } from '@inertiajs/react'
import { useEffect, useState } from 'react'
import { useI18n } from '../i18n'

/**
 * Cookie-consent banner (architecture §571). Remembers the choice in
 * localStorage (`g4-consent`); accepting dispatches `g4:consent` so
 * consent-gated features (Chatwoot, analytics) can initialise without a reload.
 * Accessible: a labelled region with real buttons; no dark patterns (Decline is
 * as prominent as Accept).
 */
const STORAGE_KEY = 'g4-consent'

export default function CookieConsent() {
  const { t } = useI18n()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(window.localStorage.getItem(STORAGE_KEY) === null)
  }, [])

  function choose(choice: 'accepted' | 'declined') {
    window.localStorage.setItem(STORAGE_KEY, choice)
    window.dispatchEvent(new CustomEvent('g4:consent', { detail: choice }))
    setVisible(false)
  }

  if (!visible) return null

  return (
    <section className="cookie-bar" aria-label={t('cookie.label')}>
      <p>
        {t('cookie.text')} <Link href="/cookies">{t('cookie.learn')}</Link>
      </p>
      <div className="cookie-actions">
        <button type="button" className="btn btn-ghost" onClick={() => choose('declined')}>
          {t('cookie.decline')}
        </button>
        <button type="button" className="btn btn-primary" onClick={() => choose('accepted')}>
          {t('cookie.accept')}
        </button>
      </div>
    </section>
  )
}
